import React from 'react';
import './NavigationArrows.css';

function NavigationArrows({ onNavigate, canGoBack = true, canGoForward = true, viewMode }) {
  return (
    <div className={`navigation-arrows ${viewMode === 'week' ? 'week-view' : ''}`}>
      <button
        className="nav-arrow nav-arrow-left"
        onClick={() => onNavigate('back')}
        disabled={!canGoBack}
        aria-label="Load more history"
      >
        ←
      </button>
      <button
        className="nav-arrow nav-arrow-right"
        onClick={() => onNavigate('forward')}
        disabled={!canGoForward}
        aria-label="Load more future"
      >
        →
      </button>
    </div>
  );
}

export default NavigationArrows;

